import { BellRing } from 'lucide-react';
import { useState } from 'react';

import AlertsDialog from '@/components/anomalies/AlertsDialog';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip';

import { useFeatures } from '@/hooks/useFeatures';

// The "watch this for me" chip: appears under chat answers (flag-gated) and
// opens the alerts sheet with the user's question pre-filled.
//
// This calls the REST endpoint like every other chip — the Docker sandbox is
// not involved, so asking for an alert costs no container slot.
interface Props {
  question: string;
}

export default function CreateAlertButton({ question }: Props) {
  const { features, loading } = useFeatures();
  const [open, setOpen] = useState(false);

  const enabled =
    !loading && !!features.anomaly_detection && !!features.anomaly_user_alerts;
  if (!enabled || !question.trim()) return null;

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setOpen(true)}
            className="text-muted-foreground"
            aria-label="Watch this and alert me"
          >
            <BellRing className="!size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Watch this and alert me when it changes</TooltipContent>
      </Tooltip>
      {open ? (
        <AlertsDialog
          open={open}
          onOpenChange={setOpen}
          initialSentence={question}
        />
      ) : null}
    </>
  );
}
